export const USAGE_TYPE_OPTIONS = [
	{
		label: 'Broadcast',
		value: 'broadcast'
	},
	{
		label: 'Online',
		value: 'online'
	},
	{
		label: 'DCP',
		value: 'dcp'
	},
	{
		label: '3D DCP',
		value: 'dcp3d'
	},
	{
		label: '35mm',
		value: 'film35'
	},
	{
		label: '70mm',
		value: 'film70'
	},
	{
		label: 'IMAX',
		value: 'imax'
	},
	{
		label: '3D IMAX',
		value: 'imax3d'
	},
	{
		label: '2D ATMOS',
		value: 'atmos2d'
	},
	{
		label: '3D ATMOS',
		value: 'atmos3d'
	},
	{
		label: '2D Dolby Vision',
		value: 'dolbyVision2d'
	},
	{
		label: '3D Dolby Vision',
		value: 'dolbyVision3d'
	}
];

export const PRINT_USAGE_TYPE_OPTIONS = [
	{
		label: 'CMYK',
		value: 'cmyk'
	},
	{
		label: 'RGB',
		value: 'rgb'
	}
];

const BroadcastOptions = [
	{
		label: 'HD',
		value: 'HD',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: 'SD 4:3',
		value: 'SD 4:3',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: 'SD 16:9',
		value: 'SD 16:9',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	}
];

const OnlineOptions = [
	{
		label: '1080p',
		value: '1080p',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1', '1:1']
	},
	{
		label: '720p',
		value: '720p',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: '480p',
		value: '480p',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: '360p',
		value: '360p',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: '1920p',
		value: '1920p',
		aspectRatios: ['9:16']
	},
	{
		label: 'Orban',
		value: 'Orban',
		aspectRatios: ['16:9', '1.85:1', '2.00:1', '2.35:1', '2.40:1']
	},
	{
		label: '1350p',
		value: '1350p',
		aspectRatios: ['4:5']
	}
];

const TheatricalOptions = [
	{
		label: '2D Flat 5.1',
		value: '2D Flat 5_1'
	},
	{
		label: '2D Scope 5.1',
		value: '2D Scope 5_1'
	}
];

const Theatrical3DOptions = [
	{
		label: '3D Flat 5.1',
		value: '3D Flat 5_1'
	},
	{
		label: '3D Scope 5.1',
		value: '3D Scope 5_1'
	}
];

const TheatricalIMAXOptions = [
	{
		label: 'IMAX Laser 5.0',
		value: 'IMAX Laser 5_0'
	},
	{
		label: 'IMAX Laser 12.0',
		value: 'IMAX Laser 12_0'
	},
	{
		label: 'IMAX Xenon 5.0',
		value: 'IMAX Xenon 5_0'
	},
	{
		label: 'IMAX Xenon 12.0',
		value: 'IMAX Xenon 12_0'
	}
];

const Theatrical3DIMAXOptions = [
	{
		label: '3D IMAX Laser 5.0',
		value: '3D IMAX Laser 5_0'
	},
	{
		label: '3D IMAX Laser 12.0',
		value: '3D IMAX Laser 12_0'
	},
	{
		label: '3D IMAX Xenon 5.0',
		value: '3D IMAX Xenon 5_0'
	},
	{
		label: '3D IMAX Xenon 12.0',
		value: '3D IMAX Xenon 12_0'
	}
];

const Theatrical2DAtmosOptions = [
	{
		label: '2D Scope Atmos',
		value: '2D Scope Atmos'
	},
	{
		label: '2D Flat Atmos',
		value: '2D Flat Atmos'
	}
];

const Theatrical3DAtmosOptions = [
	{
		label: '3D Scope Atmos',
		value: '3D Scope Atmos'
	},
	{
		label: '3D Flat Atmos',
		value: '3D Flat Atmos'
	}
];

const Theatrical2DDolbyVisionOptions = [
	{
		label: '2D Flat Dolby Vision (Atmos)',
		value: '2D Flat Dolby Vision (Atmos)'
	},
	{
		label: '2D Scope Dolby Vision (Atmos)',
		value: '2D Scope Dolby Vision (Atmos)'
	}
];

const Theatrical3DDolbyVisionOptions = [
	{
		label: '3D Flat Dolby Vision (Atmos)',
		value: '3D Flat Dolby Vision (Atmos)'
	},
	{
		label: '3D Scope Dolby Vision (Atmos)',
		value: '3D Scope Dolby Vision (Atmos)'
	}
];

const PrintOptions = [
	{
		label: 'CMYK',
		value: 'cmyk'
	}
];

const DigitalOptions = [
	{
		label: 'RGB',
		value: 'rgb'
	}
];

const RoadshowOptions = [
	{
		label: 'Physical',
		value: 'physical'
	},
	{
		label: 'Aspera',
		value: 'aspera'
	}
];

const StreamingOptions = [
	{
		label: 'Link',
		value: 'streamingfile'
	}
];

const UsageOptions = {
	broadcast: BroadcastOptions,
	online: OnlineOptions,
	theatrical: TheatricalOptions,
	theatrical3D: Theatrical3DOptions,
	theatricalIMAX: TheatricalIMAXOptions,
	theatrical3DIMAX: Theatrical3DIMAXOptions,
	theatrical2DAtmos: Theatrical2DAtmosOptions,
	theatrical3DAtmos: Theatrical3DAtmosOptions,
	theatrical2DDolbyVision: Theatrical2DDolbyVisionOptions,
	theatrical3DDolbyVision: Theatrical3DDolbyVisionOptions,
	print: PrintOptions,
	digital: DigitalOptions,
	roadshow: RoadshowOptions,
	streaming: StreamingOptions
};

export default UsageOptions;
